<template lang="pug">
.three_grid_item.d-flex.flex-column.flex-md-row.text-center.text-md-left
  img.i_m_sm_auto(:src="img")
  .content.i_ml_3.i_ml_sm_0.i_mt_sm_2
    h5.text-center.text-md-left {{ title }}
    p.d-none.d-md-block {{ subtitle }}
</template>

<script>
export default {
  name: "ThreeGridItem",
  props: {
    title: String,
    subtitle: String,
    img: String,
  },
};
</script>

<style lang="scss" scoped>
img {
  @include size(50px, 50px);
}

.content {
  h5 {
    @include font(24px, $color_black_title, normal);
    margin: 0;
  }

  p {
    @include font(18px, $color_blue_p_ci, normal);
    margin: 0;
  }
}

@media (max-width: 991px) {
  .content {
    h5 {
      font-size: 16px;
    }

    p {
      font-size: 12px;
    }
  }
}

@media (max-width: 767px) {
  img {
    @include size(88px, 88px);
  }

  .content {
    width: 137px;

    h5 {
      font-size: 22px;
    }
  }
}

@media (max-width: 575px) {
  img {
    @include size(15.2vw, 15.2vw);
  }

  .content {
    width: 23.7vw;

    h5 {
      font-size: 4.2vw;
      line-height: 7.35vw;
    }
  }
}
</style>
